import { render, staticRenderFns } from "./HeadbarPage.vue?vue&type=template&id=4cc1b0d6"
import script from "./HeadbarPage.vue?vue&type=script&lang=js"
export * from "./HeadbarPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc1b0d6')) {
      api.createRecord('4cc1b0d6', component.options)
    } else {
      api.reload('4cc1b0d6', component.options)
    }
    module.hot.accept("./HeadbarPage.vue?vue&type=template&id=4cc1b0d6", function () {
      api.rerender('4cc1b0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/HeadbarPage.vue"
export default component.exports